import { Component } from '@angular/core';

@Component({
  selector: 'pds-menu-cards-container',
  standalone: false,
  templateUrl: './menu-cards-container.component.html',
  styleUrls: ['./menu-cards-container.component.scss'],
})
export class MenuCardsContainerComponent {}
